import React from 'react';

export const getImageFileFromClipboard = (
  event: React.ClipboardEvent
): File | null => {
  const clipboardData = event.clipboardData;
  if (!clipboardData) return null;

  for (const item of Array.from(clipboardData.items)) {
    if (!item.type.startsWith('image/')) continue;
    const blob = item.getAsFile();
    if (!blob) continue;
    const extension = blob.type.split('/')[1]?.replace('jpeg', 'jpg') || 'png';
    return new File([blob], `pasted-image-${Date.now()}.${extension}`, {
      type: blob.type,
    });
  }

  return (
    Array.from(clipboardData.files).find((file) => file.type.startsWith('image/')) ??
    null
  );
};
